module.exports = __webpack_public_path__ + "img/67.2fd7710c.jpg";